export default "__VITE_ASSET__DWojN8BS__"